// Sayfa başlığı ve aksiyon butonları
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  titleAdornment?: React.ReactNode;
}

export function PageHeader({ title, description, actions, children, titleAdornment }: PageHeaderProps) {
  const actionContent = actions || children;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {titleAdornment}
        </div>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actionContent && <div className="flex flex-wrap items-center gap-2 shrink-0">{actionContent}</div>}
    </div>
  );
}
